import type { IProspect, IProspectContact, IProspectsResponse } from '../interfaces/prospects';
import { ProspectContactType, ProspectSalesModel } from '../types/prospects';

export const PROSPECTS_MOCK: IProspect[] = [
  {
    id: 1,
    companyName: 'Tech Solutions SpA',
    documentType: 'RUT',
    documentValue: '76.123.456-7',
    countryCode: 'CL',
    companySize: 'sme',
    workforceSize: 50,
    industry: 'Technology',
    city: 'Santiago',
    state: 'Región Metropolitana',
    status: 'pending_quote',
    salesModel: ProspectSalesModel.AppAndInsurance,
    contacts: [
      {
        id: 101,
        contactType: 'administrative',
        name: 'Ana García',
        email: 'a.garcia@techsolutions.cl',
        phone: '+56912345678'
      }
    ]
  },
  {
    id: 2,
    companyName: 'Constructora Del Valle Ltda',
    documentType: 'RUT',
    documentValue: '78.654.321-K',
    countryCode: 'CL',
    companySize: 'corporate',
    workforceSize: 120,
    industry: 'Construction',
    city: 'Valparaíso',
    state: 'Región de Valparaíso',
    status: 'pending_quote',
    salesModel: ProspectSalesModel.AppOnly,
    contacts: []
  },
  {
    id: 3,
    companyName: 'Retail Express S.A.',
    documentType: 'RUT',
    documentValue: '99.001.002-3',
    countryCode: 'CL',
    companySize: 'enterprise',
    workforceSize: 310,
    industry: 'Retail',
    city: 'Concepción',
    state: 'Región del Biobío',
    status: 'pending_quote',
    salesModel: ProspectSalesModel.AppAndInsurance,
    contacts: [
      {
        id: 201,
        contactType: 'administrative',
        name: 'Carlos Muñoz',
        email: 'c.munoz@retailexpress.cl'
      },
      {
        id: 202,
        contactType: 'billing',
        name: 'Carlos Muñoz',
        email: 'billing@retailexpress.cl'
      }
    ]
  },
  {
    id: 4,
    companyName: 'Tech Innovators SpA',
    documentType: 'RUT',
    documentValue: '77.999.888-1',
    countryCode: 'CL',
    companySize: 'sme',
    workforceSize: 30,
    industry: 'Technology',
    city: 'Santiago',
    state: 'Región Metropolitana',
    status: 'pending_quote',
    salesModel: ProspectSalesModel.AppOnly,
    contacts: [
      {
        id: 401,
        contactType: 'administrative',
        name: 'Pedro Soto',
        email: 'p.soto@techinnovators.cl',
        phone: '+56987654321'
      }
    ]
  }
];

export const GET_PROSPECTS_MOCK_RESPONSE = (): Promise<{ data: IProspectsResponse }> =>
  Promise.resolve({
    data: {
      pagination: { pageNumber: 1, pageSize: 100, total: PROSPECTS_MOCK.length },
      prospects: PROSPECTS_MOCK
    }
  });

export const CREATE_PROSPECT_MOCK_RESPONSE = () =>
  Promise.resolve({
    data: { id: 9999 },
    status: 201
  });

export const UPDATE_PROSPECT_MOCK_RESPONSE = () => Promise.resolve({ data: undefined, status: 204 });

export const CREATE_PROSPECT_CONTACT_MOCK_RESPONSE = () => Promise.resolve({ data: { id: 9999 }, status: 201 });

export const UPDATE_PROSPECT_CONTACT_MOCK_RESPONSE = () => Promise.resolve({ data: undefined, status: 204 });

export const ACTIVATE_PROSPECT_MOCK_RESPONSE = () =>
  Promise.resolve({
    data: {
      prospectId: 0,
      activationDate: '2019-08-24',
      quoteIds: [0]
    },
    status: 204
  });

export const PRIMARY_CONTACT_MOCK: IProspectContact = {
  id: 1,
  contactType: ProspectContactType.Administrative,
  name: 'Ana García',
  title: 'CEO',
  email: 'ana@acme.cl',
  phone: '+56911111111'
};

export const BILLING_CONTACT_MOCK: IProspectContact = {
  id: 2,
  contactType: ProspectContactType.Billing,
  name: 'Beto Pagos',
  title: 'CFO',
  email: 'beto@acme.cl',
  phone: '+56922222222'
};

export const makeProspectMock = (overrides: Partial<IProspect> = {}): IProspect => ({
  id: 1,
  companyName: 'Acme',
  workforceSize: 10,
  salesModel: ProspectSalesModel.AppAndInsurance,
  status: 'pending_activation',
  documentValue: '76.123.456-7',
  industry: 'Technology',
  street: '123 Main St',
  city: 'Santiago',
  state: 'RM',
  contacts: [PRIMARY_CONTACT_MOCK],
  ...overrides
});
